import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import Logo from "../img/Logotipo.webp";
import imgNav from "../img/fondo1.webp";
import CheeseBur from "../img/promoDuo/cheeseBurguer.webp";
import CheddarMelt from "../img/promoDuo/cheddarMelt.webp";
import CrispyM from "../img/promoDuo/cryspyMelt.webp";
import GreanjeroS from "../img/promoDuo/granjeroS.webp";
import HCarne from "../img/promoDuo/hCarne.webp";
import HClassic from "../img/promoDuo/hClassic.webp";
import Pr from "../img/promoDuo/pr.webp";
import { motion, AnimatePresence } from "framer-motion";
import { FaInfoCircle } from "react-icons/fa";
import { showSuccess } from "./Utils/toastUtils";

const promos = [
  { id: 1, img: GreanjeroS, nombre: "Granjero Sencillo Duo", precio: 5.99 },
  { id: 2, img: HCarne, nombre: "Hamburguesa de Carne Duo", precio: 6.99 },
  { id: 3, img: CheeseBur, nombre: "Cheese Burguer Duo", precio: 6.99 },
  { id: 4, img: CheddarMelt, nombre: "Cheddar Melt Duo", precio: 6.99 },
  { id: 5, img: CrispyM, nombre: "Crispy Cheddar Melt Duo", precio: 6.99 },
  { id: 6, img: HClassic, nombre: "Hot Dog Classic Duo", precio: 6.00 },
  { id: 7, img: Pr, nombre: "Papas Regulares Duo", precio: 1.99 },
];

const ingredientesPromos = [
  {
    nombre: "Duo Granjero Sencillo",
    detalle: [
      "Mayonesa, tomate, lechuga, ",
      { destacado: "pollo crispy" },
    ],
  },
  {
    nombre: "Duo Street Burger",
    detalle: [
      "Mayonesa, ketchup, salsa de ajo, mostaza, tomate, lechuga, cebolla troceada al grill, queso, papitas de perro, carne a la plancha.",
    ],
  },
  {
    nombre: "Duo H-Carne",
    detalle: [
      "Mayonesa, ketchup, mostaza, cebolla troceada, pepinillo, queso, ",
      { destacado: "carne o pollo a la plancha" },
    ],
  },
  {
    nombre: "Duo Cheese Burger",
    detalle: [
      "Queso fundido, ",
      { destacado: "carne o pollo a la plancha" },
    ],
  },
  {
    nombre: "Duo Cheddar Melt",
    detalle: [
      "Cebolla y tocineta, troceada cocidas al grill, queso fundido, salsa de cebolla dulce; ",
      { destacado: "carne o pollo a la plancha." },
    ],
  },
  {
    nombre: "Duo Crispy Cheddar Melt",
    detalle: [
      "Cebolla y tocineta, troceada cocidas al grill, queso fundido, salsa de cebolla dulce; ",
      { destacado: "pollo crispy." },
    ],
  },
  {
    nombre: "Duo 390 Classic",
    detalle: [
      "Pan, salchicha, cebolla, repollo, mayonesa, ketchup, BBQ, mostaza, papitas, queso amarillo, salsa de ajo, maíz.",
    ],
  },
];

const PromoDup = ({ onAgregarPromo, onSiguiente, onInteraccion }) => {
  const [loading, setLoading] = useState(true);
  const [imgsLoaded, setImgsLoaded] = useState(0);
  const [selectedPromoId, setSelectedPromoId] = useState(null);
  const [mostrarIngredientes, setMostrarIngredientes] = useState(false);

  const totalImages = promos.length + 2;

  useEffect(() => {
    if (imgsLoaded >= totalImages) {
      setLoading(false);
    }
  }, [imgsLoaded, totalImages]);

  const handleClickPromo = (promo) => {
    setSelectedPromoId(prev => (prev === promo.id ? null : promo.id));
  };

  const handleAgregar = (promo) => {
    // Enriquecer la promo con el tipo antes de mandar a agregar
    const promoConTipo = { ...promo, tipoModulo: "duo" };
    if (onAgregarPromo) onAgregarPromo(promoConTipo);
    showSuccess(`${promo.nombre} agregado!`);
    setSelectedPromoId(null);
  };
  
  return (
    <div className="min-h-screen !bg-transparent p-8 sm:p-8 rounded-2xl w-full flex flex-col items-center px-3 py-3 -mt-12 relative overflow-hidden">
      <img 
        src={imgNav} 
        alt="Fondo" 
        className="absolute inset-0 w-full h-full object-cover -z-10 pointer-events-none" 
        onLoad={() => setImgsLoaded(prev => prev + 1)}
      />

      {loading && (
        <motion.div
          key="loader"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="absolute inset-0 flex flex-col items-center justify-center !bg-transparent rounded-2xl z-50 pointer-events-none"
        >
          <div className="w-16 h-16 border-4 border-neutral-200 border-t-transparent rounded-full animate-spin"></div>
        </motion.div>
      )}

      <div className={`${loading ? "pointer-events-none select-none opacity-0" : "opacity-100 transition-opacity duration-500"} w-full flex flex-col items-center !bg-transparent`}>
        <img
          src={Logo}
          alt="Logo"
          className="w-32 mx-auto"
          style={{ objectFit: "contain" }}
          onLoad={() => setImgsLoaded(prev => prev + 1)}
        />

        <h1 className="text-gray-500 text-3xl font-bold mb-4 -mt-16">
          <span className="text-gray-500">Promo</span> <strong className="text-yellow-400">Duo's</strong>
        </h1>
        <h2 className="text-gray-500/50 text-sm font-bold mb-2 -mt-4">
          Para agregar un duo, solo presiona.
        </h2>

        <button
          type="button"
          className="mb-3 inline-flex items-center gap-2 rounded-full border-2 border-yellow-500 bg-white px-4 py-1.5 text-sm font-bold text-gray-700 shadow-[0_4px_14px_rgba(0,0,0,0.18)] transition hover:bg-yellow-50 active:scale-95"
          onClick={(e) => {
            e.stopPropagation();
            onInteraccion?.();
            setMostrarIngredientes(true);
          }}
        >
          <FaInfoCircle className="text-yellow-500 text-base" aria-hidden="true" />
          Ingredientes
        </button>

        <div className="w-full max-w-md flex flex-wrap justify-between items-center bg-transparent">
          {promos.map((promo, index) => (
            <div
              key={promo.id}
              className="flex flex-col items-center cursor-pointer w-[45%] relative"
              style={{ marginTop: index >= 2 ? "-3rem" : "0" }}
              onClick={() => handleClickPromo(promo)}
            >
              <p className="text-yellow-500 text-[10px] sm:text-xs text-center font-extrabold leading-tight z-10 uppercase tracking-tighter">
                {promo.nombre}
              </p>

              <div className="relative w-full">
                <div className="relative -mt-[50px] flex items-center justify-center min-h-[120px]">
                  <img
                    src={promo.img}
                    alt={promo.nombre}
                    className={`w-full h-auto object-contain rounded-md transition-opacity duration-300 ${
                      selectedPromoId === promo.id ? "opacity-0 pointer-events-none" : "opacity-100"
                    }`}
                    onLoad={() => setImgsLoaded((prev) => prev + 1)}
                  />

                  {selectedPromoId === promo.id && (
                    <div className="absolute inset-0 flex items-center justify-center">
                      <button
                        className="bg-yellow-500 text-white font-bold py-2 px-6 rounded-full shadow-lg z-30"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleAgregar(promo);
                        }}
                      >
                        Agregar
                      </button>
                    </div>
                  )}
                </div>

                <div className={`absolute top-0 right-0 bg-yellow-500 text-white text-xs sm:text-sm font-black px-2 py-0.5 rounded-full shadow-lg z-20 transition-opacity duration-300 ${
                  selectedPromoId === promo.id ? "opacity-0 pointer-events-none" : "opacity-100"
                }`}>
                  2 x ${promo.precio}
                </div>
              </div>
            </div>
          ))}

          <div className="w-[45%] flex justify-center items-center mt-[-3rem]">
            <button
              className="bg-yellow-500 text-white font-bold py-2 px-6 rounded-xl hover:bg-yellow-400 transition"
              onClick={onSiguiente}
            >
              Siguiente
            </button>
          </div>
        </div>
      </div>
      
      {mostrarIngredientes &&
        createPortal(
          <div
            className="fixed inset-0 z-[80] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4"
            onClick={() => setMostrarIngredientes(false)}
          >
            <div
              className="bg-white rounded-2xl w-full max-w-md max-h-[80vh] overflow-y-auto p-5 shadow-xl relative"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                type="button"
                aria-label="Cerrar ingredientes"
                className="absolute top-3 right-3 bg-black/20 text-white w-8 h-8 rounded-full font-bold"
                onClick={() => setMostrarIngredientes(false)}
              >
                ×
              </button>

              <h3 className="text-yellow-500 text-lg font-extrabold uppercase tracking-wide text-center mb-4 pr-6">
                Promoción Duos
              </h3>

              <div className="flex flex-col gap-4">
                {ingredientesPromos.map((promo) => (
                  <div key={promo.nombre}>
                    <p className="text-gray-700 font-extrabold text-sm">{promo.nombre}</p>
                    <p className="text-gray-500 text-sm leading-snug">
                      {promo.detalle.map((parte, i) =>
                        typeof parte === "string" ? (
                          <span key={i}>{parte}</span>
                        ) : (
                          <strong key={i} className="text-gray-700">
                            {parte.destacado}
                          </strong>
                        )
                      )}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>,
          document.body
        )}

      <style>{`
        .bg-white.rounded-2xl.w-\\[90\\%\\].max-w-sm.sm\\:max-w-md.lg\\:max-w-lg.max-h-\\[80vh\\] {
          background: transparent !important;
          box-shadow: none !important;
        }
      `}</style>
    </div>
  );
};

export default PromoDup;
